module.exports = __webpack_public_path__ + "img/roman-abramovich.cd6013ea.png";